import { EnvironmentStore } from '@nx-vigil/core/web/environment/data-access';
import { NGXLogger, NgxLoggerLevel } from 'ngx-logger';
import { firstValueFrom } from 'rxjs';

interface LoggingConfig {
  level?: NgxLoggerLevel;
  serverLogLevel?: NgxLoggerLevel;
}

export function setupLogging(
  store: EnvironmentStore,
  logger: NGXLogger,
): () => Promise<void> {
  return async () => {
    const logging: LoggingConfig = await firstValueFrom(
      store.getConfiguration$('logging'),
    );

    logger.partialUpdateConfig({
      level: NgxLoggerLevel.TRACE,
      serverLogLevel: NgxLoggerLevel.OFF,
      ...logging,
    });

    logger.log('Logging initialized', logger.getConfigSnapshot());
  };
}
